module.exports = __webpack_public_path__ + "assets/images/gli_y.c0137456.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/gli_y.png
// module id = 719
// module chunks = 1